<template>
    <div>

        <!--logo-->
        <div class="dl_logo">
            <img src="/img/wx.png">
            <text>微信授权登录</text>
        </div>

        <!--logo end-->


        <div class="wx-qlogo"><img src="/img/slogo.jpg"></div>


        <!--登录-->
        <div class="f_but">
            <button>微信授权登录</button>
        </div>
        <!--登录 end-->


    </div>
</template>

<script>
    import {Toast, Indicator} from 'mint-ui';

    export default {
        data() {
            return {
                WX_APPID: 'wxdeb299d0ac1e265a',

            };
        },
        created() {

            // this.initShare()
            this.init()
        },
        mounted() {
            window.onscroll = () => {
                //变量scrollTop是滚动条滚动时，距离顶部的距离
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                //变量windowHeight是可视区的高度
                var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                //变量scrollHeight是滚动条的总高度
                var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                //滚动条到底部的条件
                if (scrollTop + windowHeight == scrollHeight) {
                    //写后台加载数据的函数
                    //this.getList()
                }
            }
        },
        methods: {
            init() {
                //授权获取code
                let code = this.$route.code;
                console.log("code>>>>" + code)
                if (code) {
                    Indicator.open({
                        text: '加载中...',
                        spinnerType: 'fading-circle'
                    });
                    //通过code登录
                    R.User.checkingH5User({
                        code: code
                    }).then(result => {
                        Indicator.close();
                        let res = result.result;
                        if (result.code != 10000) {
                            Toast(res.msg);
                        } else {
                            //登录成功
                            if (res.roleType == '5') {
                                //没绑定手机号
                                return;
                            }
                            //去之前页面
                            let beforeLoginUrl = window.localStorage.getItem("beforeLoginUrl");
                            if (!beforeLoginUrl) {
                                //首页
                                beforeLoginUrl = '/'
                            }
                            window.location.href = beforeLoginUrl;
                        }

                    })
                } else {
                    //没有微信用户信息，没有授权-->> 需要授权，跳转授权页面
                    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.WX_APPID + '&redirect_uri=' + window.location.href + '/author&response_type=code&scope=snsapi_userinfo#wechat_redirect';
                }
            },
        },
        computed: {}
    };
</script>

<style scoped>
    .dl_logo {
        background: #32a658;
        height: 172px;
        text-align: center;
    }

    .dl_logo img {
        display: block;
        width: 65px;
        margin: 0 auto;
        padding-top: 50px;
    }

    .dl_logo text {
        font-size: 14px;
        display: block;
        text-align: center;
        color: #FFF;
        margin-top: 14px;
    }

    .wx-qlogo {
        width: 214px;
        margin: 0 auto;
        margin-top: 115px;
    }

    .wx-qlogo img {
        width: 214px;
    }

    .f_but {
        padding: 15px 0;
        margin-top: 118px;
        text-align: center;
    }

    .f_but button {
        border: none;
        display: inline-block;
        width: 182px;
        height: 40px;
        line-height: 38px;
        text-align: center;
        background: #32a658;
        color: #fff;
        font-size: 16px;
        border-radius: 100px;
        font-weight: bolder;
        font-family: "Microsoft YaHei UI Light", "微软雅黑";
        margin: 0 10px;
    }

    .no-margin {
        margin-bottom: 15px
    }
</style>
